import { useForm } from "react-hook-form";
import Layout from "../../components/layouts/layout.comp";
import MembershipEditor from "../../components/membership/membershipEditor";
import { useTranslation } from "../../core/translation.core";
import { MembershipFormData } from "../../types/membership";
import membershipCore from "../../core/membership.core";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { EditingMode } from "../../components/reuseables/form.comp";

export default function ProductCreatePage() {
  const { t, msg } = useTranslation();
  const queryClient = useQueryClient();
  const router = useRouter();

  const methods = useForm<MembershipFormData>({
    defaultValues: {
      issueMode: "auto",
      discountType: "percentage",
      rewardMultiplier: 1,
      autoIssueCriteria: { placement: "both" },
      default: false,
      productRestriction: { type: "none", restrictToIds: [] },
      categoryRestriction: { type: "none", restrictToIds: [] },
    },
  });

  const mutation = useMutation({
    mutationFn: async (data: MembershipFormData) => {
      await membershipCore.create({ ...data, default: !!data.default });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["memberships"] });
      router.push("/memberships");
    },
    onError: (e) => {
      if (e.message.includes("codeAlreadyExists")) {
        methods.setError("code", { message: "this code has already been used" });
      }
    },
  });

  return (
    <Layout title={t(msg.membership.createTier)}>
      <MembershipEditor methods={methods} btnText={t(msg.form.create)} mutation={mutation} editingMode={EditingMode.create} />
    </Layout>
  );
}
